<template>
  <v-app>
    <core-app-bar />

    <core-drawer />

    <core-about-us-view />

    <core-footer />

  </v-app>
</template>

<script>
export default {
  name: 'AboutUs',

  components: {
    CoreAppBar: () => import('../components/core/AppBar'),
    CoreDrawer: () => import('../components/core/Drawer'),
    CoreAboutUsView: () => import('../components/core/AboutUsView'),
    CoreFooter: () => import('../components/core/Footer'),
  },

  data: () => ({
    expandOnHover: false,
  }),
}
</script>
